__turbopack_context__.v({
  "caption": "styles-module__8PjxuG__caption",
  "content": "styles-module__8PjxuG__content",
  "countdown": "styles-module__8PjxuG__countdown",
  "countdownWrapper": "styles-module__8PjxuG__countdownWrapper",
  "dropDateCopy": "styles-module__8PjxuG__dropDateCopy",
  "headingWithIcon": "styles-module__8PjxuG__headingWithIcon",
  "headingWrapper": "styles-module__8PjxuG__headingWrapper",
  "remindMeButton": "styles-module__8PjxuG__remindMeButton",
  "remindMeButtonWrapper": "styles-module__8PjxuG__remindMeButtonWrapper",
  "reminderSetLabel": "styles-module__8PjxuG__reminderSetLabel",
  "signupButton": "styles-module__8PjxuG__signupButton",
  "signupButtonWrapper": "styles-module__8PjxuG__signupButtonWrapper",
  "wrapper": "styles-module__8PjxuG__wrapper",
});
